module.exports = __webpack_public_path__ + "static/media/1.a44ed389.jpg";